import React from 'react';
import { useAlert } from '@uplift/ui-v2';
import { CollaborativeAgreementSigned } from '@uplift/api';
import { useCollaboratePhysicianMatchByIdForPhysicianQuery, useCounterSignCollaborativeAgreementMutation, useUserDisplayNameQuery } from '@uplift/queries';
import { Typography } from '@mui/material';
import { useCurrentuser } from '@uplift/contexts';
import { AgreementSigningForm } from './AgreementSigningForm';
import { SignatureBlock, SignatureCard } from './SignatureCard';


export const CounterSignAgreementCard = React.forwardRef<HTMLDivElement, {
  document: CollaborativeAgreementSigned;
  onSign: (agreementId: string) => void;
}>(({ document, onSign }, ref) => {
  const me = useCurrentuser();
  const { data: match } = useCollaboratePhysicianMatchByIdForPhysicianQuery(me.id, document.collaborativeMatchId);
  const { data: providerName } = useUserDisplayNameQuery(match.providerId, { suspense: true });
  const { data: physicianName } = useUserDisplayNameQuery(match.collaborativePhysicianId, { suspense: true });
  const counterSignMutation = useCounterSignCollaborativeAgreementMutation(me.id);
  const alert = useAlert();

  return (
    <SignatureCard ref={ref} title="Counter-sign this agreement">
      <AgreementSigningForm
        consentLabel="By checking this, I confirm I am the Collaborating Physician named in this agreement and agree this constitutes my legal electronic counter-signature."
        onSubmit={async () => {
          const counterSignedAgreementId = await counterSignMutation.mutateAsync({
            signedAgreementId: document.id,
          });

          onSign(counterSignedAgreementId);
          alert.success('Successfully counter-signed the agreement');
        }}
      >
        <Typography variant="body2" color="textSecondary">
          Nurse Practitioner: {providerName.fullLegalName}
        </Typography>
        <SignatureBlock name={physicianName.fullLegalName} />
      </AgreementSigningForm>
    </SignatureCard>
  );
});
